"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Analysis_1 = __importDefault(require("./Analysis"));
var Base_1 = __importDefault(require("../data/Base"));
var Query = /** @class */ (function (_super) {
    __extends(Query, _super);
    function Query(orgId, analysisId, queryId) {
        var _this = _super.call(this, queryId) || this;
        _this.getPath = function () { return _this.queryPath; };
        _this.delete = function () {
            return _this.deleteByPath(_this.getPath());
        };
        _this.getAnalysis = function () {
            return _this.analysis;
        };
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/queries/" + uid);
        };
        _this.getConfig = function (id) {
            return _this.getByPath("/queries_config/" + _this.orgId + "/" + _this.analysisId + "/" + _this.id + "/config");
        };
        _this.updateConfig = function (configObject) {
            return _this.update("/queries_config/" + _this.orgId + "/" + _this.analysisId + "/" + _this.id + "/config", configObject);
        };
        _this.activeUsers = function () {
            return _this.getByPath("/active_query_users/" + _this.orgId + "/" + _this.analysisId + "/" + _this.id);
        };
        _this.getQueryInfo = function () {
            return _this.getByPath("" + _this.queryPath);
        };
        _this.getVersions = function () {
            return _this.getByPath(_this.queryPath + "/versions");
        };
        _this.createVersion = function (versionObject) {
            return _this.create(_this.queryPath + "/versions", versionObject);
        };
        _this.getHistory = function () {
            return _this.getByPath(_this.queryPath + "/history");
        };
        _this.createHistory = function (messageObject) {
            return _this.create(_this.queryPath + "/history", messageObject);
        };
        _this.getComments = function () {
            return _this.getByPath(_this.queryPath + "/comments");
        };
        _this.createComment = function (commentObject) {
            return _this.create(_this.queryPath + "/comments", commentObject);
        };
        _this.requestDeleteQuery = function (uid) {
            var request = {
                audit: {
                    createdBy: uid
                },
                analysisId: _this.analysisId,
                queryId: _this.id
            };
            return _this.create("/apis/" + _this.orgId + "/" + uid + "/delete_query", request);
        };
        _this.analysis = new Analysis_1.default(orgId, analysisId);
        _this.analysisId = analysisId;
        _this.orgId = orgId;
        _this.queryPath = "/queries/" + _this.orgId + "/" + _this.analysisId + "/" + _this.id;
        return _this;
    }
    return Query;
}(Base_1.default));
exports.default = Query;
//# sourceMappingURL=Query.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Query.js
// module id = 222
// module chunks = 8